<!-- 单条件查询 -->
<template>
  <li>
    <a-input type="text" size="large" placeholder="请输入" v-model="formData.keyWord" />
  </li>
</template>

<script>
export default {
  name: "SingleCondition",
  data() {
    return {
      formData: {
        keyWord: "",
      },
    };
  },
};
</script>
